import React from "react";
import store from "../store";
import PropTypes from "prop-types";
import classNames from "classnames";
import { withStyles } from "@material-ui/core/styles";
import ReactPlayer from "react-player";
import IntlTelInput from "react-intl-tel-input";
import "react-intl-tel-input/dist/main.css";
import Grid from "@material-ui/core/Grid";
import Button from "@material-ui/core/Button";
import MenuItem from "@material-ui/core/MenuItem";
import TextField from "@material-ui/core/TextField";
import Typography from "@material-ui/core/Typography";

import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import hideOnScroll from '../components/hideonscroll'
import MenuIcon from '@material-ui/icons/Menu';
import Avatar from '@material-ui/core/Avatar';
import { NotificationManager } from 'react-notifications';
import CircularProgress from '@material-ui/core/CircularProgress';

import { Link } from "react-router-dom";

import TopBar from '../components/TopBar';
import Paper from '@material-ui/core/Paper';

import { Redirect } from 'react-router-dom';
import ButtonBase from '@material-ui/core/ButtonBase';
import PowerIcon from '@material-ui/icons/PowerSettingsNew';
import firebase from "firebase/app";
import "firebase/firestore";
import "firebase/auth";
import "firebase/storage";
import { FIREBASE } from "../config/firebase";
import Divider from '@material-ui/core/Divider';
import * as STATIC from '../config/static';
import _ from 'lodash';
import moment from "moment";
import {Helmet} from "react-helmet";
import Modal from 'react-responsive-modal';
import {
  EmailShareButton,
  FacebookShareButton,
  TwitterShareButton,
  FacebookIcon,
  TwitterIcon,
  EmailIcon

} from "react-share";
const DWIDTH = 1024;
if (!firebase.apps.length) {
  firebase.initializeApp(FIREBASE);
}
function getParameterByName(name) {
    if (name !== "" && name !== null && name !== undefined) {
        name = name.replace(/[[]/, "\\[").replace(/[\]]/, "\\]");
        var regex = new RegExp("[\\?&]" + name + "=([^&#]*)"),
            results = regex.exec(window.location.search);
        return results === null ? "" : decodeURIComponent(results[1].replace(/\+/g, " "));
    } else {
        var arr = window.location.href.split("/");
        return arr[arr.length - 1];
    }
}
function validateEmail(email) {
  var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(String(email).toLowerCase());
}
function validatePhone(phone) {
  var re = /^([0-9]{6,20})$/;
  return re.test(phone);
};

const firestore = firebase.firestore();
//let IS_NAMING = window.location.hostname.toLowerCase()=='www1.namethegiraffe.com'?true:false;
//IS_NAMING = true;


var _this;

class CompHome extends React.Component {
  state = {
    viewDidLoad: false,
  };
  constructor() {
    super();
    window.document.title="Test";
    _this = this;
    let comp_id = getParameterByName("comp");
    let acc_id = getParameterByName("u");
    let level = getParameterByName("level");
    level = parseInt(level)-1;
    let round = getParameterByName("round");
    round = parseInt(round)-1;

    this.state={isPlaying:false,results:[],ACCOUNTCOMP:{},comp_id,acc_id,level,round,myResult:null,showSharing:false};
    _this.audio = new Audio("assets/sound/inner_bg.mp3");
    //let urlParams = new URLSearchParams(window.location.search);

  }
  updateDimensions() {
    //console.log(window.innerWidth);
    // _this.setState({
    //   innerWidth: window.innerWidth,
    //   innerHeight: window.innerHeight
    // });
  }
  componentDidMount() {

    this.updateWindowDimensions();
    window.addEventListener('resize', this.updateWindowDimensions);
    //this.loadComp();
    //let encrypted = STATIC.encryptStringWithRsaPublicKey("JK1234");
    //console.log(encrypted);
    this.loadAccount();

    // this.setState({
    //   innerWidth: window.innerWidth,
    //   innerHeight: window.innerHeight
    // });
    //window.addEventListener("resize", this.updateDimensions);
    //this.loadResults();
  }
  async loadAccount(){
    const {round,level}=_this.state;
    if(!_this.state.acc_id||_this.state.acc_id.length==0)
    {
      return;
    }
    let ACCOUNTCOMP = {};
    let comp = {};


     let data = await firebase.firestore().collection('comps').where("comp_id","==",_this.state.comp_id).get();
     if(data.size>0)
     {
       data.forEach(d=>{
         comp = d.data();
         comp.id = d.id;
       })
     }
     let rel = await firebase.firestore().collection('comps').doc(comp.id).collection("Level_"+level+"_Round_"+round).doc(_this.state.acc_id).get();
     //console.log(rel.exists);
     if(rel.exists)
     {
       ACCOUNTCOMP = rel.data();
       ACCOUNTCOMP.id = rel.id;
     }
     //console.log(ACCOUNTCOMP)
     _this.setState({ACCOUNTCOMP,comp});
     _this.loadResults();
    //
    //   if(data.size>0)
    //   {
    //
    //     data.forEach(d=>{
    //       comp = d.data();
    //       comp.id = d.id;
    //     })
    //   }
    //   //console.log("Data");
    //   _this.setState({comp});
    //   if(!_this.state.loaded)
    //   {
    //     _this.setState({loaded:true,loading:false});
    //   }
    //   if(comp)
    //   {
    //     _this.setState({comp});
    //   }
    // })
    // _this.setState({sub});
    //let data = await firebase.firestore().collection('comps').where('comp_id',"==",ACCOUNTCOMP.comp_id).get();


    //console.log(sDoc.exists)

  }
  async loadResults(){
    //let ACCOUNTCOMP = _this.state.ACCOUNTCOMP;
    const {comp,round,level,ACCOUNTCOMP}=_this.state;
    let mData = await firebase.firestore().collection('comps').doc(comp.id).collection("Level_"+level+"_Round_"+round).doc(ACCOUNTCOMP.id).get();
    let myResult = null;
    if(mData.exists)
    {
      myResult = mData.data();
      if(!myResult.ranking)
      myResult.ranking = 0;
    }
    //console.log(myResult)
    _this.setState({myResult})
    //console.log(comp_id,round,level);

    firebase.firestore().collection('comps').doc(comp.id).collection("Level_"+level+"_Round_"+round).orderBy("total_point","desc").limit(10000).get().then((data)=>{
      let results = [];
      console.log(data.size)
      let showRankLimit = comp.levels[level].rounds[round].showRankLimit||100;
      if(data.size>0)
      {
        let count = 1;
        data.forEach((doc) => {
          let item = doc.data();
          item.index = count ;
          if(count<=showRankLimit)
          results.push(item);
          if(myResult&&item.username==myResult.username)
          {
            myResult.ranking = count;
          }
          count++;
        });
        let arr = [];
        // for(let i=0;i<80;i++)
        // {
        //   let index = _.random(results.length - 1);
        //   let item = _.cloneDeep(results[index]);
        //   item.index = i+1;
        //   arr.push(item);
        // }
        // results = arr;
      }

      //console.log(results);
      _this.setState({results});

    });
    //_this.setState({sub});
    //console.log(comp.id,data.size,"Round_"+round)

  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.updateWindowDimensions);
    if(this.state.sub)
    this.state.sub();
  }

  updateWindowDimensions() {
    _this.setState({ wWidth: window.innerWidth, wHeight: window.innerHeight });
  }
  handleChange = name => event => {
    //event.preventDefault();
    _this.setState({ [name]: event.target.value });
  };



  getName(fullname)
  {
    return _.last(fullname.split(' '));
  }


  render() {
    const { classes,t } = this.props;
    const { loading, wWidth, wHeight,results,myResult,showSharing,acc_id,comp_id,level,round,comp } = this.state;
    let width = 1024;
    let height = 640;

    // if (wWidth < width) {
    //   width = wWidth;
    // }

      height = wHeight;

    let sRate = 1024 / 640;
    let tRate = 1523 / 725;
    let asRate = 121 / 2048;
    let tsRate = 1523/2048;
    //if (width / wHeight > sRate) {
      width = wHeight * sRate;
      if(width>wWidth)
      {
          width = wWidth;
          height = width/sRate;
      }
    let tWidth = width*tsRate;
    let tHeight = tWidth/tRate;
    //}
    let fBig = width * 0.07;
    let fLarge = width * 0.06;
    let fTitle = width * 0.04;
    let fNormal = width * 0.03;
    let fSmall = width * 0.02;
    let fSmaller = width * 0.015;
    let ACCOUNTCOMP = _this.state.ACCOUNTCOMP;
    let SOUND = store.getState().SOUND;




    let bWidth = STATIC.calSize(512, DWIDTH, width);
    let itemStyle = {textAlign:'center',fontSize:fSmaller,whiteSpace:"nowrap"};
    let limit = Math.ceil(results.length/2.0);
    let shareUrl = `https://app.superbrain.edu.vn/comp_ranking?comp=${comp_id}&u=${acc_id}&level=${level+1}&round=${round+1}`;
    //let shareTitle = "[SUPERBRAIN] Kết quả vòng "+(round+1)+" - "+(ACCOUNTCOMP&&ACCOUNTCOMP.ten?ACCOUNTCOMP.ten:"SUPEBRAIN");
    let compname = (comp&&comp.name?comp.name:"SUPEBRAIN SPEED MATH").replace(/(?:\r\n|\r|\n)/g, ' ');
    let shareTitle = "Thí sinh "+(ACCOUNTCOMP&&ACCOUNTCOMP.ten?ACCOUNTCOMP.ten:"SUPEBRAIN")+" đang tham gia cuộc thi "+compname+" - nhấp vào để xem kết quả vòng "+(round+1);


    //console.log(ACCOUNT);
    return (
      <div className={classes.root} style={{backgroundImage:comp&&comp.bg_main&&comp.bg_main.length>0?("url('"+comp.bg_main+"')"):"url('assets/comp/bg_comp.png')"}}>
        <div className={classes.middle} >




          <div className={classes.square} style={{maxWidth:width, width: width,height:height,backgroundImage: comp&&comp.bg_rank&&comp.bg_rank.length>0?("url('"+comp.bg_rank+"')"):"url('assets/comp/bg_cong.png')",
          backgroundPosition: "center center",
          WebkitBackgroundSize: "100% 100%",
          backgroundSize: "100% 100%",position:'relative' }} elevation={4}>
          <Helmet>
                <meta charSet="utf-8" />
                <title>{"Kết quả của "+(ACCOUNTCOMP.ten||acc_id)}</title>
                <meta name="description" content="" />

            </Helmet>
            <div style={{paddingTop:STATIC.calSize(60, DWIDTH, width) + 'px '}}>{" "}</div>
            <div style={{  flexGrow: 1, position: 'relative' }}>

              <div style={{ display: 'flex', height: tHeight,flexDirection:'column', justifyContent: 'center', alignItems: 'center' }}>
              <div  style={{width: tWidth,height:tHeight,backgroundImage: "url('assets/comp/cong_table.png')",
              backgroundPosition: "center center",
              WebkitBackgroundSize: "100% 100%",
              backgroundSize: "100% 100%",position:'relative' }} elevation={4}>
              <div className="comp_table" style={{padding:STATIC.calSize(30, DWIDTH, width)}}>
                <div style={{width:tWidth*0.9}}>
                  <div style={{display:'flex',flexDirection:'row'}}>
                  <div className="comp_text_gradient2" style={{width:tWidth*0.05,...itemStyle}}>{t("comp.rank")}</div>
                    <div className="comp_text_gradient2" style={{width:tWidth*0.16,...itemStyle}}>{t("comp.number")}</div>
                    <div className="comp_text_gradient2" style={{width:tWidth*0.11,...itemStyle}}>{t("comp.agent")}</div>
                    <div className="comp_text_gradient2" style={{width:tWidth*0.12,...itemStyle}}>{t("comp.point")}</div>
                    <div className="comp_text_gradient2" style={{width:tWidth*0.02,...itemStyle}}></div>
                    <div className="comp_text_gradient2" style={{width:tWidth*0.05,...itemStyle}}>{t("comp.rank")}</div>
                    <div className="comp_text_gradient2" style={{width:tWidth*0.16,...itemStyle}}>{t("comp.number")}</div>
                    <div className="comp_text_gradient2" style={{width:tWidth*0.11,...itemStyle}}>{t("comp.agent")}</div>
                    <div className="comp_text_gradient2" style={{width:tWidth*0.12,...itemStyle}}>{t("comp.point")}</div>

                  </div>
                  <div style={{width:tWidth*0.9,height:STATIC.calSize(3, DWIDTH, width),backgroundColor:"#dbe55f"}}></div>
                  <div className="comp_table" style={{width:tWidth*0.9,height:tHeight*0.7,marginTop:STATIC.calSize(5, DWIDTH, width),overflowX:'hidden',display:'flex',flexDirection:'row'}}>
                    <div>
                      {myResult!=null&&<div style={{display:'flex',flexDirection:'row'}}>
                        <div className={myResult?"comp_text_gradient":"comp_text_gradient2"} style={{width:tWidth*0.05,...itemStyle}}>{STATIC.pad(myResult.ranking,3)}</div>
                        <div className={myResult?"comp_text_gradient":"comp_text_gradient2"} style={{width:tWidth*0.16,...itemStyle,display:"flex",flexDirection:"row"}}><Avatar alt="" src={myResult.image||"/assets/comp/sp_logo_red.png"} sx={{ width: 30, height: 30 }} style={{width:STATIC.calSize(25, DWIDTH, width),height:STATIC.calSize(25, DWIDTH, width)}} /><div className={myResult?"comp_text_gradient":"comp_text_gradient2"}> {myResult.username}</div></div>
                        <div className={myResult?"comp_text_gradient":"comp_text_gradient2"} style={{width:tWidth*0.11,...itemStyle}}>{myResult.ma_cs}</div>
                        <div className={myResult?"comp_text_gradient":"comp_text_gradient2"} style={{width:tWidth*0.12,...itemStyle}}>{parseFloat(myResult.total_point).toFixed(3)}</div>
                        <div style={{width:tWidth*0.002,backgroundColor:"#dbe55f"}}></div>
                      </div>}
                    {[...Array(limit).keys()].map((l,index)=>{
                      let r = results[index];
                      let myResult = ACCOUNTCOMP.username == r.username;
                      return <div key={index} style={{display:'flex',flexDirection:'row'}}>
                        <div className={myResult?"comp_text_gradient":"comp_text_gradient2"} style={{width:tWidth*0.05,...itemStyle}}>{STATIC.pad(r.index,3)}</div>
                        <div className={myResult?"comp_text_gradient":"comp_text_gradient2"} style={{width:tWidth*0.16,...itemStyle,display:"flex",flexDirection:"row"}}><Avatar alt="" src={r.image||"/assets/comp/sp_logo_red.png"} sx={{ width: 30, height: 30 }} style={{width:STATIC.calSize(25, DWIDTH, width),height:STATIC.calSize(25, DWIDTH, width)}} /><div className={myResult?"comp_text_gradient":"comp_text_gradient2"}> {r.username}</div></div>
                        <div className={myResult?"comp_text_gradient":"comp_text_gradient2"} style={{width:tWidth*0.11,...itemStyle}}>{r.ma_cs}</div>
                        <div className={myResult?"comp_text_gradient":"comp_text_gradient2"} style={{width:tWidth*0.12,...itemStyle}}>{parseFloat(r.total_point).toFixed(3)}</div>
                        <div style={{width:tWidth*0.002,backgroundColor:"#dbe55f"}}></div>
                      </div>
                    })}
                    </div>

                      <div>
                        {myResult!=null&&<div  style={{display:'flex',flexDirection:'row'}}>
                          <div className={myResult?"comp_text_gradient":"comp_text_gradient2"} style={{width:tWidth*0.05,...itemStyle}}></div>
                          <div className={myResult?"comp_text_gradient":"comp_text_gradient2"} style={{width:tWidth*0.16,...itemStyle,display:"flex",flexDirection:"row"}}><Avatar alt="" src={"/assets/comp/empty.png"} sx={{ width: 30, height: 30 }} style={{width:STATIC.calSize(25, DWIDTH, width),height:STATIC.calSize(25, DWIDTH, width)}} /></div>
                          <div className={myResult?"comp_text_gradient":"comp_text_gradient2"} style={{width:tWidth*0.11,...itemStyle}}>{" "}</div>
                          <div className={myResult?"comp_text_gradient":"comp_text_gradient2"} style={{width:tWidth*0.12,...itemStyle}}></div>

                        </div>}
                      {[...Array(limit).keys()].map((l,index)=>{
                        let newIndex = limit+index;
                        if(newIndex>=results.length)
                        return false;
                        let r = results[newIndex];
                        let myResult = ACCOUNTCOMP.username == r.username;
                        return <div key={index} style={{display:'flex',flexDirection:'row'}}>
                          <div className={myResult?"comp_text_gradient":"comp_text_gradient2"} style={{width:tWidth*0.05,...itemStyle}}>{STATIC.pad(r.index,3)}</div>
                          <div className={myResult?"comp_text_gradient":"comp_text_gradient2"} style={{width:tWidth*0.16,...itemStyle,display:"flex",flexDirection:"row"}}><Avatar alt="" src={r.image||"/assets/comp/sp_logo_red.png"} sx={{ width: 30, height: 30 }} style={{width:STATIC.calSize(25, DWIDTH, width),height:STATIC.calSize(25, DWIDTH, width)}} /><div className={myResult?"comp_text_gradient":"comp_text_gradient2"}> {r.username}</div></div>
                          <div className={myResult?"comp_text_gradient":"comp_text_gradient2"} style={{width:tWidth*0.11,...itemStyle}}>{r.ma_cs}</div>
                          <div className={myResult?"comp_text_gradient":"comp_text_gradient2"} style={{width:tWidth*0.12,...itemStyle}}>{parseFloat(r.total_point).toFixed(3)}</div>

                        </div>
                      })}
                      </div>
                </div>

                </div>
              </div>


              </div>

            </div>
            </div>
            <div style={{width,position:'absolute',bottom:STATIC.calSize(150, DWIDTH, width),left:STATIC.calSize(0,DWIDTH, width),display: 'flex', flexDirection:'column', justifyContent: 'center', alignItems: 'center'}}>
              <div className="comp_text_gradient"  style={{fontSize:fLarge,whiteSpace: "pre",textAlign:'center',lineHeight:1 }}>{"CONGRATULATION"}</div>
            </div>
            <div style={{width,position:'absolute',bottom:STATIC.calSize(80, DWIDTH, width),left:STATIC.calSize(0,DWIDTH, width),display: 'flex', flexDirection:'column', justifyContent: 'center', alignItems: 'center'}}>
              <div className="comp_text_gradient"  style={{fontSize:fLarge,whiteSpace: "pre",textAlign:'center',lineHeight:1 }}>{ACCOUNTCOMP.ten}</div>
            </div>
            <div  style={{position:'absolute',top:STATIC.calSize(10, DWIDTH, width),left:STATIC.calSize(365,DWIDTH, width),width:width*574/2048,height:(width*574/2048)*377/1427,backgroundImage:"url('assets/comp/square_name.png')",backgroundSize:"100% 100%", textAlign: 'center',display:'flex',justifyContent: 'center', alignItems: 'center' }}>
              <div className="comp_text_gradient"  style={{fontSize:fNormal,whiteSpace: "pre",textAlign:'center',lineHeight:0.8}}>{comp?comp.name:"SUPERBRAIN\nSPEED MATH"}</div>
            </div>
            <div  style={{position:'absolute',top:STATIC.calSize(10, DWIDTH, width),right:STATIC.calSize(30,DWIDTH, width), textAlign: 'center',display:'flex',justifyContent: 'center', alignItems: 'center' }}>
              <img
                src="assets/comp/sp_logo_red.png"
                style={{ width: width*154/2048, height: 'auto', display: 'block' }} />
            </div>
            <ButtonBase onClick={()=>{this.setState({showSharing:true})}} style={{display:'flex',flexDirection:'column',position:'absolute',bottom:STATIC.calSize(50, DWIDTH, width),right:STATIC.calSize(50,DWIDTH, width)}}>
              <img
                src="assets/comp/share_button.png"
                style={{ width: width*123/2048, height: 'auto', display: 'block' }} />
                <div className="comp_text_gradient"  style={{fontSize:fSmaller,whiteSpace: "pre",textAlign:'center',lineHeight:1 }}>{t("comp.share")}</div>
            </ButtonBase>

          </div>

        </div>
        <Modal styles={{overlay:{padding:0}, modal: { minWidth: width * 0.8, background: 'none', boxShadow: 'none', color: "white" } }} showCloseIcon={false} focusTrapped={false} open={showSharing} onClose={() => this.setState({ loading: false })} center>
          <div style={{ width: "100%", backgroundColor: 'rgba(101, 163, 67, 0.1)', position: 'relative', borderRadius: STATIC.calSize(10, STATIC.DWIDTH, STATIC.DWIDTH), padding: STATIC.calSize(10, STATIC.DWIDTH, STATIC.DWIDTH) }}>
            <div style={{ display: 'flex',flexDirection:'column' }}>

                <div style={{textAlign: 'center', fontSize: fNormal, marginTop: STATIC.calSize(10, STATIC.DWIDTH, STATIC.DWIDTH)}}>{t("comp.share")}</div>
                <div style={{display: 'flex',flexDirection:"row", justifyContent: 'center', alignItems: 'center'}}>
                  <FacebookShareButton
          url={shareUrl}
          quote={shareTitle}
          className=""
        >
          <FacebookIcon size={STATIC.calSize(80, DWIDTH, width)} round />
        </FacebookShareButton>
        <TwitterShareButton
            url={shareUrl}
            title={shareTitle}
            className=""
          >
            <TwitterIcon size={STATIC.calSize(80, DWIDTH, width)} round />
          </TwitterShareButton>
          <EmailShareButton
            url={shareUrl}
            subject={shareTitle}
            body={shareTitle}
            className=""
          >
            <EmailIcon size={STATIC.calSize(80, DWIDTH, width)} round />
          </EmailShareButton>

          <Helmet>

                <script src="https://sp.zalo.me/plugins/sdk.js"></script>
            </Helmet>
          <div className="zalo-share-button" data-href={shareUrl} data-oaid="1231916658948067083" data-layout="1" data-color="blue" data-customize="true"><img src={"assets/web/zalo.png"} style={{width:STATIC.calSize(80, DWIDTH, width),height:STATIC.calSize(80, DWIDTH, width)}}></img></div>
                </div>
                  <div style={{ display: 'flex', height: STATIC.calSize(205, DWIDTH, width), justifyContent: 'center', alignItems: 'center', marginBottom: STATIC.calSize(30, DWIDTH, width) }}>

                    <div style={{ flexGrow: 1, display: 'flex', alignItems: 'center' }}>
                      <input
                        value={shareUrl}
                        autoComplete="off"
                        type="text"
                        disabled={true}
                        className="comp_input"

                        style={{ border: 'none',textAlign:'center', height: STATIC.calSize(175, DWIDTH, width), width: '100%', padding: '0px ' + STATIC.calSize(20, DWIDTH, width) + 'px', fontSize: fNormal }} />
                    </div>
                  </div>
                <div style={{display:'flex',flexDirection:'row',justifyContent:'center',alignItems:'center', marginTop: STATIC.calSize(10, STATIC.DWIDTH, width) }}>
                  <Button onClick={()=>this.setState({showSharing:false})} style={{marginTop: STATIC.calSize(5, STATIC.DWIDTH, width), color: "#053f22", padding: (STATIC.calSize(6, STATIC.DWIDTH, width) + 'px ' + STATIC.calSize(16, STATIC.DWIDTH, width) + 'px'), minWidth: 0, backgroundColor: '#fdce07', fontWeight: 'bold', fontSize: fSmall, display: 'block', textTransform: "capitalize", fontWeight: 'normal' }} size="large" variant="contained"  >
                  {t("comp.close")}
                  </Button>
                  <div style={{flexGrow:1}}>

                  </div>
                  <Button onClick={()=>{navigator.clipboard.writeText(shareUrl);STATIC.NotificationManager.success(t("comp.copied"))}} style={{marginTop: STATIC.calSize(5, STATIC.DWIDTH, width), color: "#053f22", padding: (STATIC.calSize(6, STATIC.DWIDTH, width) + 'px ' + STATIC.calSize(16, STATIC.DWIDTH, width) + 'px'), minWidth: 0, backgroundColor: '#fdce07', fontWeight: 'bold', fontSize: fSmall, display: 'block', textTransform: "capitalize", fontWeight: 'normal' }} size="large" variant="contained"  >
                  {t("comp.copy")}
                  </Button>

                </div>
                </div>
              </div>
        </Modal>




      </div>
    );
  }
}

CompHome.propTypes = {
  classes: PropTypes.object.isRequired
};

export default withStyles(STATIC.styles2)(STATIC.translate('common')(CompHome));
